import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Checkbox } from '@repo/common';

const PostCheckboxRow = ({
  label,
  checked = false,
  onChange,
  disabled = false,
  className,
  children,
}) => {
  return (
    <div
      className={twMerge(
        'w-full flex flex-col bg-grayscale-gray00 py-1.5',
        'tabletH:rounded-lg tabletH:border tabletH:border-grayscale-gray02 tabletH:px-4 tabletH:py-3',
        disabled && 'bg-grayscale-gray01',
        className,
      )}
    >
      <div className='flex items-center'>
        <Checkbox
          checked={checked}
          onChange={onChange}
          label={label}
          disabled={disabled}
          className='w-full h-5'
          labelClassName={twMerge(
            'typo-b14 tabletH:typo-b16',
            disabled
              ? 'text-text-placeholder'
              : 'text-text-primary tabletH:text-text-tertiary',
          )}
        />
      </div>

      {children && <div className='mt-4'>{children}</div>}
    </div>
  );
};

export default PostCheckboxRow;
